import { createContext } from "react";
import { GraphStore } from "../../store";

export const GraphContext = createContext<GraphStore | null>(null);
